import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import "./almsoffering.css";
import { MdAccessTime, MdLocationOn, MdPeople, MdEmail, MdPhone, MdPerson, MdNotes, MdEvent, MdVolumeUp } from "react-icons/md";

function AlmsOffering() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchBookings = async () => {
      if (!auth.currentUser) {
        setLoading(false);
        return;
      }

      const userEmail = auth.currentUser.email;
      
      try {
        // Fetch alms giving appointments
        const appointmentsRef = collection(db, "appointments");
        const almsQuery = query(appointmentsRef, where("email", "==", userEmail));
        const almsSnapshot = await getDocs(almsQuery);
        
        // Fetch dhamma events
        const eventsRef = collection(db, "dhammaEvents");
        const eventsQuery = query(eventsRef, where("email", "==", userEmail));
        const eventsSnapshot = await getDocs(eventsQuery);
        
        // Combine both types of bookings
        const almsBookings = almsSnapshot.docs.map(doc => ({
          id: doc.id,
          type: 'alms',
          ...doc.data(),
          date: doc.data().date?.toDate(),
          createdAt: doc.data().createdAt?.toDate()
        }));
        
        const eventBookings = eventsSnapshot.docs.map(doc => ({
          id: doc.id,
          type: 'dhamma',
          ...doc.data(),
          date: doc.data().date?.toDate(),
          createdAt: doc.data().createdAt?.toDate()
        }));
        
        // Sort all bookings by date (newest first)
        const allBookings = [...almsBookings, ...eventBookings].sort((a, b) => b.date - a.date);
        
        setBookings(allBookings);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
      setLoading(false);
    };

    fetchBookings();
  }, [auth, db]);

  const formatDate = (date) => {
    if (!date) return "Date not specified";
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };


  
  return (
    <>
      <section className="hero-container">
        <div className="hero-image-container">
          <img src="/dharma.png" alt="Alms Offering" />
        </div>
        <div className="hero-content">
          <h1>Ehipassiko Buddhist Centre</h1>
          <p>
            Let us come together in harmony, share in this noble practice,
            and receive the boundless blessings of the Triple Gem.
          </p>
        </div>
      </section>

      <div className="membership-profile-container">
        <h2 className="membership-profile-header">Your Bookings</h2>
        {loading ? (
          <p>Loading...</p>
        ) : bookings.length > 0 ? (
          <div className="bookings-list">
            {bookings.map((booking, index) => (
              <div key={booking.id || index} className="booking-card">
                <div className="booking-header">
                  <h3>
                    {booking.type === 'alms' ? (
                      <>
                        <MdAccessTime /> {booking.mealType === 'breakfast' ? 'Breakfast' : 'Lunch'} Offering
                      </>
                    ) : (
                      <>
                        <MdVolumeUp /> {booking.eventType}
                      </>
                    )}
                  </h3>
                  <span className="booking-date">{formatDate(booking.date)}</span>
                </div>
                
                <div className="booking-details">
                  <div className="detail-row">
                    <MdPerson className="detail-icon" />
                    <span>{booking.name}</span>
                  </div>
                  <div className="detail-row">
                    <MdEmail className="detail-icon" />
                    <span>{booking.email}</span>
                  </div>
                  <div className="detail-row">
                    <MdPhone className="detail-icon" />
                    <span>{booking.phone}</span>
                  </div>
                  
                  {booking.type === 'alms' ? (
                    <>
                      <div className="detail-row">
                        <MdPeople className="detail-icon" />
                        <span>Number of Monks: {booking.numberOfPeople}</span>
                      </div>
                      <div className="detail-row">
                        <MdLocationOn className="detail-icon" />
                        <span>Location: {booking.location}</span>
                      </div>
                      <div className="detail-row">
                        <MdAccessTime className="detail-icon" />
                        <span>
                          Time: {booking.mealType === 'breakfast' ? '7:00 AM - 8:30 AM' : '11:00 AM - 1:00 PM'}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="detail-row">
                        <MdPeople className="detail-icon" />
                        <span>Expected Attendees: {booking.numberOfPeople}</span>
                      </div>
                      <div className="detail-row">
                        <MdAccessTime className="detail-icon" />
                        <span>Time: {booking.timeSlotDisplay}</span>
                      </div>
                    </>
                  )}
                  
                  {booking.specialRequests && (
                    <div className="detail-row">
                      <MdNotes className="detail-icon" />
                      <span>Special Requests: {booking.specialRequests}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-abstraction">
            You haven't made any bookings yet. <br /><br />
            With hearts full of reverence, we warmly invite you to be part
            of our spiritual activities at the Ehipassiko Buddhist Center.
          </p>
        )}
      </div>
    </>
  );
}

export default AlmsOffering;